<template>
  <div class="container-fluid my-3" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex title-box">
          <div class="title" :class="{'active': currentPage==='classify'}"  @click="doSubTitle('classify')">{{$t('Personal.Exam.Placement_test')}}</div>
          <div class="title" v-if="examRole" :class="{'active': currentPage==='regular'}" @click="doSubTitle('regular')">{{$t('Personal.Exam.Monthly_mock_test')}}</div>
          <div class="title" v-if="examRole" :class="{'active' : currentPage==='simulation'}"  @click="doSubTitle('simulation')">{{$t('Personal.Exam.More_practice')}}</div>
        </div>
      </div>
    </div>
    <div class="alert alert-warning" role="alert">
      為提供最佳應考體驗，請以電腦完成本區測驗
    </div>
    <div v-if="currentPage === 'classify'">
      <div style="text-align:left">
        <h6>
          在導入課程前，請先進行學前測驗，以了解目前 TOEIC 與對應 CEFR 英語程度，以下說明：
        </h6>
        <ul class="pl-3">
          <li>每位學員限定只能測驗一次，須以筆電或桌上型電腦進行，請確認目前使用電腦進入本測驗。</li>
          <li>測驗題型：模擬最新多益題型，考完立即呈現成績結果。</li>
          <li>測驗題數：包含聽力 50 題與閱讀 50 題，滿分 990 分。</li>
          <li>測驗時間：約 60 分鐘，畫面右上角有倒數計時，提醒作答剩餘時間。</li>
        </ul>
      </div>
      <table class="rwd-table">
        <tr>
          <th>{{$t('Personal.Exam.Result')}}</th>
          <th>{{$t('Personal.Exam.Exam_date')}}</th>
          <th>{{$t('Personal.Exam.Test_time')}}</th>
          <th>{{$t('Personal.Exam.Listening_score')}}</th>
          <th>{{$t('Personal.Exam.Reading_score')}}</th>
          <th>{{$t('Personal.Exam.Total_score')}}</th>
          <th class="rwd-hide">{{$t('Personal.Exam.State')}}</th>
          <th class="rwd-hide">{{$t('Personal.Exam.Details')}}</th>
        </tr>
        <tr v-for="(item, index) in exams" :key="index">
          <td class="rwd-td" :data-th="$t('Personal.Exam.Result')"> {{item.cefr}}</td>
          <td :data-th="$t('Personal.Exam.Exam_date')"> {{item.finished_at?item.finished_at:'未測驗'}}</td>
          <td :data-th="$t('Personal.Exam.Test_time')"> {{item.total_time}}</td>
          <td :data-th="$t('Personal.Exam.Listening_score')"> {{item.listening_score?item.listening_score:'-'}}</td>
          <td :data-th="$t('Personal.Exam.Reading_score')"> {{item.reading_score?item.reading_score:'-'}}</td>
          <td :data-th="$t('Personal.Exam.Total_score')"> {{item.score?item.score:'-'}}</td>
          <td class="rwd-hide" :data-th="$t('Personal.Exam.Start')">
            <button v-if="!item.finished_at" type="button" @click="examAlert(item)" class="btn btn-danger">Start</button>
            <button v-else :disabled="item.finished_at" type="button" class="btn btn-danger">Finished</button>
          </td>
          <td class="rwd-hide" :data-th="$t('Personal.Exam.Details')">
            <button :disabled="!item.finished_at" type="button" class="btn btn-danger m-1" @click="goDetailAnswer(item)">Detailed</button>
          </td>
        </tr>
      </table>
      <div class="explanation" v-for="(item, index) in chats" :key="index" style="text-align:left">
        <div v-if="item.level=== cefr">
          <h4>您的學前測驗分級結果是 <span class="red-text"> {{cefr}}</span>，以下是您的英語能力與學習建議說明:</h4>
          <div class="mt-3">
            <h5 class="red-text">英語能力</h5>
            <ul>
              <li v-for="(txt, idx) in item.text" :key="idx">{{txt}}</li>
            </ul>
          </div>
          <div class="mt-3">
            <h5 class="red-text">學習建議</h5>
            <p>{{item.advice}}​</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentPage === 'regular'">
      <div style="text-align:left">
        <h6>
          為挑戰自我實力，每月提供新多益模擬測驗，以提升多益應考實力，以下說明：
        </h6>
        <ul class="pl-3">
          <li>每位學員限定每月只能測驗一次，須以筆電或桌上型電腦進行，請確認目前使用電腦進入本測驗。</li>
          <li>測驗題型：模擬最新多益題型，考完立即呈現成績結果。</li>
          <li>測驗題數：包含聽力 50 題與閱讀 50 題，滿分 990 分。</li>
          <li>測驗時間：約 60 分鐘，畫面右上角有倒數計時，提醒作答剩餘時間。</li>
          <li>月考期間：每月 1 號自動開放，開放時間請以網站公告為準，若超過當月考試期限無法補考，請於下月再進入測驗。</li>
        </ul>
        <h6>最近開放時間:   {{moment(monthlyExam.begin_at).format('YYYY/MM/DD') }} - {{moment(monthlyExam.end_at).format('YYYY/MM/DD') }}</h6>
      </div>
      <div class="alert alert-dark" role="alert">
        當月測驗
      </div>
      <div  class="d-flex">
        <table>
          <tr>
            <th>{{$t('Personal.Exam.Month')}}</th>
            <th>{{$t('Personal.Exam.Exam_date')}}</th>
            <th>{{$t('Personal.Exam.Test_time')}}</th>
            <th>{{$t('Personal.Exam.Listening_score')}}</th>
            <th>{{$t('Personal.Exam.Reading_score')}}</th>
            <th>{{$t('Personal.Exam.Total_score')}}</th>
          </tr>
          <tr>
            <td :data-th="$t('Personal.Exam.Month')">{{monthlyExam.month}}</td>
            <td :data-th="$t('Personal.Exam.Exam_date')" style="width:200px">{{monthlyExam.finished_at?monthlyExam.finished_at:'未測驗'}}</td>
            <td :data-th="$t('Personal.Exam.Test_time')">{{monthlyExam.total_time}}</td>
            <td :data-th="$t('Personal.Exam.Listening_score')">{{monthlyExam.listening_score?monthlyExam.listening_score:'-'}}</td>
            <td :data-th="$t('Personal.Exam.Reading_score')">{{monthlyExam.reading_score?monthlyExam.reading_score:'-'}}</td>
            <td :data-th="$t('Personal.Exam.Total_score')">{{monthlyExam.score?monthlyExam.score:'-'}}</td>
          </tr>
        </table>
        <button style="width:250px" v-if="!allowExam"  type="button" class="btn btn-outline-danger" disabled>{{ timeStamp(time)}}後開始測驗</button>
        <button style="width:250px" v-if="monthlyExam.finished_at !== null && allowExam"  type="button" class="btn btn-outline-danger" disabled>完成考試</button>
        <button style="width:250px" v-if="allowExam && monthlyExam.finished_at === null" type="button" class="btn btn-outline-danger" @click="examAlert(monthlyExam)">Start</button>
      </div>
      <div class="record" v-if="exams">
        <div class="alert alert-dark mt-4" role="alert" v-if="exams">
          測驗紀錄
        </div>
        <table v-for="(item, index) in exams" :key="index">
          <tr>
            <th>{{$t('Personal.Exam.Month')}}</th>
            <th>{{$t('Personal.Exam.Exam_date')}}</th>
            <th>{{$t('Personal.Exam.Test_time')}}</th>
            <th>{{$t('Personal.Exam.Listening_score')}}</th>
            <th>{{$t('Personal.Exam.Reading_score')}}</th>
            <th>{{$t('Personal.Exam.Total_score')}}</th>
            <th class="rwd-hide">{{$t('Personal.Exam.Details')}}</th>
          </tr>
          <tr>
            <td :data-th="$t('Personal.Exam.Month')">{{item.month}}</td>
            <td :data-th="$t('Personal.Exam.Exam_date')" style="width:200px">{{item.finished_at?item.finished_at:'未測驗'}}</td>
            <td :data-th="$t('Personal.Exam.Test_time')">{{item.total_time}}</td>
            <td :data-th="$t('Personal.Exam.Listening_score')">{{item.listening_score?item.listening_score:'-'}}</td>
            <td :data-th="$t('Personal.Exam.Reading_score')">{{item.reading_score?item.reading_score:'-'}}</td>
            <td :data-th="$t('Personal.Exam.Total_score')">{{item.score?item.score:'-'}}</td>
            <td class="rwd-hide" :data-th="$t('Personal.Exam.Details')">
              <button :disabled="!item.finished_at" type="button" class="btn btn-danger m-1" @click="goMonthDetailAnswer(item)">Detailed</button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="currentPage === 'simulation'">
      <div style="text-align:left">
        <h6>
          本區新多益練習考，考後提供詳細解析，以下說明：
        </h6>
        <ul class="pl-3  mb-0">
          <li>可反覆多次練習，系統自動記錄最近一次作答成績。</li>
          <li>須以筆電或桌上型電腦進行，請勿用手機和平板考試。</li>
          <li>第 1 回 - 第 4 回：每回測驗時間約 30 分鐘，包含聽力 25 題與閱讀 25 題，共 50 題。</li>
          <li>第 5 回 - 第 10 回：每回測驗時間約 60 分鐘，包含聽力 50 題與閱讀 50 題，共 100 題。</li>
          <li>第 11 回 - 第 14 回：每回測驗時間約 120 分鐘，包含聽力 100 題與閱讀 100 題，共 200 題。</li>
        </ul>
        <span>（本區同多益專區 > 多益練習考）</span>
      </div>
      <div v-for="(item, index) in exams" :key="index">
        <div class="d-flex">
          <table class="rwd-table">
            <tbody>
              <tr>
                <th style="text-align:center;min-width: 250px;" rowspan="2"> {{item.name}}</th>
                <th style="width:200px">{{$t('Personal.Exam.Exam_date')}}</th>
                <th>{{$t('Personal.Exam.Test_time')}}</th>
                <th>{{$t('Personal.Exam.Listening_score')}}</th>
                <th>{{$t('Personal.Exam.Reading_score')}}</th>
                <th>{{$t('Personal.Exam.Total_score')}}</th>
                <th>{{$t('Personal.Exam.Number_of_exercises')}}</th>
              </tr>
              <tr>
                <td class="rwd-td" style="display:none" :data-th="item.name">
                </td>
                <td :data-th="$t('Personal.Exam.Exam_date')">
                  {{item.finished_at?item.finished_at:'未測驗'}}
                </td>
                <td :data-th="$t('Personal.Exam.Test_time')">
                  {{item.total_time}}
                </td>
                <td :data-th="$t('Personal.Exam.Listening_score')">
                  {{item.listening_score?item.listening_score:'-'}}
                </td>
                <td :data-th="$t('Personal.Exam.Reading_score')">
                  {{item.reading_score?item.reading_score:'-'}}
                </td>
                <td :data-th="$t('Personal.Exam.Total_score')">
                  {{item.score?item.score:'-'}}
                </td>
                <td :data-th="$t('Personal.Exam.Number_of_exercises')">
                  {{item.count}}
                </td>
              </tr>
            </tbody>
          </table>
          <button type="button" style="width:80px" class="btn btn-danger m-1" @click="examAlert(item)">Start</button>
          <button :disabled="!item.finished_at" type="button" style="width:80px" class="btn btn-danger m-1" @click="goDetailAnswer(item)">Detailed</button>
          <!-- <button type="button" style="width:80px" class="btn btn-danger m-1" @click="downloadCertificate(item)">Test</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import api from '../store/api'
export default {
  name: 'ExamArea',
  data () {
    return {
      exams: [],
      currentPage: 'classify',
      monthlyExam: {},
      allowExam: false,
      time: 0,
      cefr: '',
      chats: [
        {
          level: 'A1',
          text:[
            '運用所學的字母拼讀規則拼寫、讀出英文字詞與簡單語句。​',
            '以正確的發音及適切語速朗讀簡易對話、歌謠韻文、故事短劇。​',
            '聽懂日常生活應對中的常用語句，如:自我介紹、居住地、人際關係，​ 並能作簡短的回應。'
          ],
          advice: '此階段學員建議從發音規則開始打好基礎，學習英文的音節、重音及語調，接著熟記基礎單字。有了一定的字彙量後，即可學習簡易的生活實用句子，並可搭配互動課程內的跟讀功能，藉由聆聽原音與實際開口練習，為基本表達能力奠定基礎。建議學習課程類別與名稱：【生活英文】我想學好發音、我想學好基礎1200字。【學習資源】日常對話好用句、我想學社交必備句。'
        },
        {
          level: 'A2',
          text:[
            '聽懂日常生活對話、簡易故事、簡易廣播，並能以簡單的字詞、句子記下要點。​​',
            '看懂日常溝通中簡易的書信、 簡訊、 留言、賀卡、邀請卡等，並能以口語或書面作簡短的回應。​​',
            '掌握重要的閱讀技巧如擷取大意、猜測字義、推敲文意、預測後續文意及情節發展……等。​'
          ],
          advice: '此階段學員已具備基本字彙量，建議進一步熟記互動課程中的單字片語用法，利用字典的查詢與收藏功能，建立專屬自己的字庫，並交互運用課程中的文字學習模式反覆聆聽及跟讀，除可增進閱讀能力，也可培養各種生活、社交、旅遊等情境的問答能力。另針對想提高多益分數的學員，則建議先透過名師講解的文法與聽力影片課程，釐清基礎文法觀念及熟悉測驗的基本應考技巧，並熟記多益必考單字。建議學習課程類別與名稱：【生活英文】日常實用情境、去旅行吧、週末放輕鬆、節慶文化。【多益專區】必考單字、多益文法解題、多益聽力解析。【學習資源】我想學社交必備句、易混淆字大解析、英文好好玩。'
        },
        {
          level: 'B1',
          text:[
            '以正確的發音及適切的斷句、節奏、語調、語氣及速度，流暢地朗讀短文、短劇及故事，並能以自己的話轉述談話或故事。​',
            '在工作時，能閱讀工作須知、公告、操作手冊、例行的文件、傳真、電報等。​​',
            '能了解及閱讀比較不同體裁、不同主題之文章，並據以發表心得、進行評析。​'
          ],
          advice: '此階段學員已具備一定的閱讀能力與字彙量，也能在工作時，閱讀例行的英文文件。建議可進一步觸及各類的生活題材，拓展知識的同時，又能增進英語的語感與口語表達能力。另可搭配基礎商業英文課程，透過情境影片學習職場的基本詞彙和實用語句，訓練工作上的溝通應對。針對想突破多益高分的學員，則建議熟悉文法觀念及加強應考技巧，並利用專區內的多益練習試題，提升應考實力。建議學習課程類別與名稱：【生活英文】健康好食尚、知識大百科、老外帶你遊臺灣。【商業英文】商務會議、電話客服、社交接待、團隊溝通、上班族輕鬆學、商英必備句。【多益專區】多益文法解題、多益聽力解析、多益練習考。【學習資源】最新話題字。'
        },
        {
          level: 'B2',
          text:[
            '能夠理解具體或抽象的話題，包括與自身專業領域相關的技術性研討。​',
            '日常生活中聽得懂演講、報導與節目；工作時，能聽懂簡報、討論、產品介紹及操作說明。 ',
            '能夠接待外籍人士、介紹工作內容、洽談業務、在會議中發言，以及撰寫工作報告和書信。​'
          ],
          advice: '此階段學員已能理解不同主題、具體或抽象的話題，也可在工作場合中用英語開會、報告或介紹產品。建議學員除加強生活英文的廣度，可著重於商務英語的專業能力，藉由短劇模擬的商務情境及中外師搭配的重點解析，掌握跨文化溝通的要領與用語。更可進一步從短篇報導的新聞英語，逐漸累積時事詞彙並訓練英語聽力。若準備參加TOEIC檢定，也可先利用多益專區內的模擬試題來加強作答速度與提升正確率。建議學習課程類別與名稱：【生活英文】健康好食尚、知識大百科。【商業英文】商務會議、簡報英語、業務行銷、商展旅行、經營管理、商務風格誌。【新聞英語】CNN全球新聞。【多益專區】多益練習考。'
        },
        {
          level: 'C1',
          text:[
            '能聽懂各類各類主題的談話、辯論、演講、報導及節目等。​',
            '能閱讀各類不同主題、體裁的文章，包括報章雜誌、文學作品、專業期刊、學術著作及文獻等。​',
            '對各類主題均能流暢地表達看法、參與討論，能在一般會議或專業研討會中報告或發表意見等，並能撰寫專業性報告、論文、新聞報導。​'
          ],
          advice: '此階段的學員除自身領域外，也能理解或談論跨領域的英文內容，並於商務場合流利地表達自我。建議學員除加強生活英文的深度，可多從新聞英語的長篇報導增進國際觀，學習最道地的口語說法，並熟悉各國口音。更可藉由關閉影片字幕的模式，訓練英語聽力與理解能力。除可依自身需求選擇課程學習，建議學習重點課程類別與名稱：【生活英文】健康好食尚、知識大百科、名人超新星。【新聞英語】品牌專題、名人專訪、科技創新、商業財經、生活趨勢、人文藝術。'
        }
      ]
    }
  },
  computed: {
    examRole () {
      if (this.$store.state.auth.user.forcePreTest) {
        if (this.$store.state.auth.user.isFinishPreTest) {
          return true
        }else {
          return false
        }
      }else {
        return true
      }
    }
  },
  mounted () {
    this.getExamData()
    this.getMonthlyExam()
    this.timer = setInterval(this.countdown, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async getExamData () {
      const { data } = await api.get(`/contents/exams?page=1&pageSize=20&type=${this.currentPage}`)
      this.exams = data.data
      this.cefr = data.data[0].cefr
    },
    async getExamId (id) {
      const { data } = await api.get(`/contents/exams/${id}`)
      return data.data.view_id
    },
    async getMonthlyExam () {
      // const self = this
      const { data } = await api.get(`/contents/monthly_exam`)
      this.monthlyExam = data.data
      const beginTime = new Date(data.data.begin_at)
      this.time = (Date.parse(beginTime) - Date.now())/1000
    },
    async getMonthlyExamRecord () {
      const { data } = await api.get(`/contents/monthly_exams`)
      this.exams = data.data
    },
    examAlert (el) {
      const vm = this
      this.$swal({
        title: '測驗提醒',
        icon: 'info',
        text: '本測驗須以電腦考試，請確認目前使用電腦進入本測驗。',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(function (isConfirm) {
      if (isConfirm.value === true) {
        vm.goExam (el)
      }})
    },
    async goExam (el) {
      if (this.currentPage === 'regular') {
        await this.getExamId(el.exam_id).then((val) => {
          if (val) {
            this.$router.push({ name: 'Examination', params: { examId: el.exam_id, viewId: val } })
          }
        } )
      }else {
        this.$router.push({ name: 'Examination', params: { examId: el.id, viewId: el.view_id } })
      }
    },
    goDetailAnswer (el) {
      this.$router.push({ name: 'DetailAnswer', params: { examId:el.id, viewId: el.view_id, recordId: el.record_id } })
    },
    goMonthDetailAnswer (el) {
      console.log(el)
      this.$router.push({ name: 'DetailAnswer', params: { examId:el.id, viewId: el.exam_id, recordId: el.record_id } })
    },
    doSubTitle (el) {
      this.currentPage = el
      if (el !== 'regular') {
        this.getExamData()
      } else {
        this.getMonthlyExamRecord()
      }
    },
    countdown() {
      this.time --
      if (this.time <= 0 ) {
        this.allowExam = true
        clearInterval(this.timer)
      }
    },
    async downloadCertificate (item) {
      return api.post(`/certificate/toeic_mocking_test?exam_id=${item.id}`, {} , {responseType: 'blob'}).then ((response) => {
        if (response) {
          let fileName = `Certificate_${item.id}`
          const url = URL.createObjectURL(new Blob([response.data],{
            type: 'image/png'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        } else {
          return Promise.reject()
        }
      })
    },
    timeStamp (s) {
      var time = parseInt(s) + "秒"
      if( parseInt(s)> 60) {
        var second = parseInt(s) % 60
        var min = parseInt(s / 60)
        time = min + "分" + second + "秒"
        if( min > 60 ){
          min = parseInt(s / 60) % 60;
          var hour = parseInt( parseInt(s / 60) /60 );
          time = hour + "小時" + min + "分" + second + "秒";

          if( hour > 24 ){
            hour = parseInt( parseInt(s / 60) /60 ) % 24;
            var day = parseInt( parseInt( parseInt(s / 60) /60 ) / 24 );
            time = day + "天" + hour + "小時" + min + "分" + second + "秒";
          }
        }
      }
      return time
    }
  },
  components: {
    // Video
  }
}
</script>
<style lang="scss" scoped>
table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
}
th {
  overflow:hidden;
  background: #428bca;
  border: 4px solid #fff;
  color: #fff;
  text-align: center !important;
  padding: 8px;
}
td {
  background-color: rgb(230, 230, 230);
  border: 4px solid #fff;
  text-align: center !important;
  padding: 8px;
}
.title-box {
  margin-bottom: 20px;
  border-top: #aaa solid 1px;
  border-bottom: #aaa solid 1px;
  padding: 10px 0;
  .title {
    color: #aaa;
    margin: 0 50px 0 0;
    cursor: pointer;
  }
  .active {
    color: black;
  }
}
.explanation{
  margin: 20px 0 50px 0;
  .red-text {
    font-weight: bold;
    color: red;
  }
  ul {
    list-style-type:decimal;
    padding: 0 20px;
  }
}
.rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: #428bca;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) "： ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  button  {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    text-align: left  !important;
  }
  .rwd-hide {
    display: none !important;
  }
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    padding: 1em !important;
  }
  .alert-warning {
    display: none !important;
  }
}
</style>
